interface AboutModalProps {
  isOpen: boolean
  onClose: () => void
  title?: string
  body?: string
}

export function AboutModal({ isOpen, onClose, title, body }: AboutModalProps) {
  if (!isOpen) return null

  return (
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-[var(--bg-secondary)] border border-[var(--border-color)] rounded-lg w-full max-w-lg max-h-[80vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-[var(--border-color)]">
          <h2 className="text-lg font-bold text-[var(--text-primary)]">אודות</h2>
          <button
            onClick={onClose}
            className="p-1 rounded hover:bg-[var(--bg-tertiary)] transition-colors text-[var(--text-secondary)] text-xl leading-none"
          >
            &times;
          </button>
        </div>

        {/* Content */}
        <div className="p-6 text-center space-y-4">
          {title && (
            <h3 className="text-2xl font-bold text-[var(--text-primary)]">
              {title}
            </h3>
          )}
          {body ? (
            <p className="text-[var(--text-primary)] whitespace-pre-line leading-relaxed">
              {body}
            </p>
          ) : !title ? (
            <p className="text-[var(--text-secondary)]">
              RADIO NATKA
            </p>
          ) : null}
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-[var(--border-color)] flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-[var(--accent)] hover:bg-[var(--accent-hover)] text-white font-medium transition-colors"
          >
            סגור
          </button>
        </div>
      </div>
    </div>
  )
}
